import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PATHS } from './paths';

/** Requires a logged-in patient; otherwise sends them to login and returns them afterwards. */
export default function ProtectedRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to={PATHS.login} replace state={{ from: location.pathname + location.search, fromState: location.state }} />;
  }
  return <Outlet />;
}
